import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DesignService } from '../../core/services/design.service';

@Component({
  selector: 'app-identity-verification-handoff',
  templateUrl: './identity-verification-handoff.component.html',
  styleUrls: ['./identity-verification-handoff.component.scss'],
})
export class IdentityVerificationHandoffComponent implements OnInit {
  isDesktopHandoff = false;

  constructor(
    private designService: DesignService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.designService.setHeaderStyle('auth');
  }

  ngOnInit(): void {
    const handoff = this.route.snapshot.queryParamMap.get('handoff');
    this.isDesktopHandoff = handoff === 'desktop';
    if (this.isDesktopHandoff) {
      return;
    }

    const verification = this.route.snapshot.queryParamMap.get('verification');
    this.router.navigate(['/signup'], {
      queryParams:
        verification === 'pending' || verification === 'completed'
          ? { verification }
          : undefined,
    });
  }
}
